import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import TextArea from "../TextArea"

import ThemeConsumer from "../ThemeConsumer"

const ModernFloatLabelTextArea = ({
  theme,
  preset,
  cssClasses,
  noResize,
  disabled,
  type,
  id,
  label,
  error,
  containerClasses,
  value,
  margin,
  ...props
}) => {
  const marginClass = theme[`margin_${margin}`]
  const containerTextArea = classnames(
    containerClasses,
    theme.floatLabel,
    marginClass,

    {
      [theme.invalid]: error,
      [theme.disabled]: disabled
    }
  )

  const textAreaClass = classnames(cssClasses, {
    [theme.noResize]: noResize
  })

  return (
    <div className={containerTextArea}>
      <TextArea
        {...props}
        disabled={disabled}
        id={id}
        preset={preset}
        type={type}
        className={textAreaClass}
        value={value}
      />

      {label && (
        <label htmlFor={id} className={theme.label}>
          {label}
        </label>
      )}

      {error && <span className={theme.error}>{error}</span>}
    </div>
  )
}

ModernFloatLabelTextArea.propTypes = {
  theme: PropTypes.shape({
    floatLabel: PropTypes.string,
    invalid: PropTypes.string,
    disabled: PropTypes.string,
    noResize: PropTypes.string,
    error: PropTypes.string,
    label: PropTypes.string
  }),
  preset: PropTypes.string,
  cssClasses: PropTypes.string,
  noResize: PropTypes.bool,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  containerClasses: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  margin: PropTypes.string
}

ModernFloatLabelTextArea.defaultProps = {
  placeholder: ""
}

export default ThemeConsumer("UIInputTextArea")(ModernFloatLabelTextArea)



// WEBPACK FOOTER //
// ./src/shared/components/ModernFloatLabelTextArea/index.js